<template>
  <div class="main-footer">
    <div class="copyright">
      <p>
        Copyright 2017All Rights Reserved 版权所有
        全国循环流化床机组技术交流服务协作平台
      </p>
      <p>
        <span>运营单位：北京国化联经济信息咨询有限公司</span>
        <span style="margin-left:25px">深圳市盛世中兴科技有限公司</span>
      </p>
      <!-- 山西平朔煤矸石发电有限公司技术中心 -->
      <p>
        通讯地址：北京市海淀区玉泉路2号
        <span>联系电话：010-68278970，0546-8553123</span>
        <span>邮箱：cfbchina@163.com</span>
        <span>邮编：100143</span>
      </p>
      <p>
        网络技术支持：深圳市盛世中兴科技有限公司
        <!-- <el-link
                    href="http://www.beian.miit.gov.cn/state/outPortal/loginPortal.action"
                    target="_blank"
                    :underline="false"
                >-->
        <span class="beian" @click="toBeian">京ICP备17044411号-1</span>
        <!-- </el-link> -->
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: 'cfb-code',
      beian: 'www.beian.miit.gov.cn/state/outPortal/loginPortal.action', // 工信部备案地址
      links: []
    }
  },
  created() {},
  methods: {
    getLinks() {
      this.httpGet(this.$root.getLinks, {})
        .then((result) => {
          this.links.push(...result.list)
        })
        .catch((err) => {
          console.error('getLinks-err', err)
        })
    },
    top() {
      window.scrollTo(0, 0)
    },
    toBeian() {
      //   window.location.href =
      //     "http://www.beian.miit.gov.cn/stateF/outPortal/loginPortal.action";
      window.open(
        'http://www.beian.miit.gov.cn/state/outPortal/loginPortal.action'
      )
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.main-footer {
    width: 100%;
    height: 256px;
    margin-bottom: 0;
    flex-center();
    background: url('~@/assets/img/black-footer.png') no-repeat;
    background-size: 100% 100%;
}

.copyright {
    flex-y(center);

    p {
        height: 28px;
        font-size: 14px;
        color: white;
        line-height: 28x;
    }

    span {
        margin-left: 10px;
    }

    margin-top: 13px;
}

.beian:hover {
    cursor: pointer;
}
</style>
